module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-mini-2-md-58ca8ab8d15dcfb995632524e573da79.png";